const storageKey = 'myaiphotoshoot.stripeCheckout.v1';
const maxAgeMs = 48 * 60 * 60 * 1000;

function pendingCheckout() {
    const raw = window.sessionStorage.getItem(storageKey);
    if (!raw) return null;
    try {
        const pending = JSON.parse(raw);
        const age = Date.now() - pending.createdAt;
        if (!/^cs_(?:live|test)_[A-Za-z0-9]+$/.test(pending.checkoutSessionId) ||
            typeof pending.userId !== 'string' || !pending.userId ||
            typeof pending.returnRoute !== 'string' || typeof pending.createdAt !== 'number' ||
            !Number.isFinite(age) || age < 0 || age > maxAgeMs || !pending.details) {
            throw new Error('Invalid checkout return context');
        }
        return pending;
    } catch {
        window.sessionStorage.removeItem(storageKey);
        return null;
    }
}

export function storeCheckoutReturn(userId, checkoutSessionId, details, returnRoute) {
    if (!/^cs_(?:live|test)_[A-Za-z0-9]+$/.test(checkoutSessionId) || typeof userId !== 'string' || !userId) {
        throw new Error('Invalid Stripe checkout account or session');
    }
    const pending = JSON.stringify({
        userId,
        checkoutSessionId,
        createdAt: Date.now(),
        returnRoute,
        details: JSON.parse(details),
    });
    // Persist before leaving: storage failures must leave the purchase retryable in the app.
    window.sessionStorage.setItem(storageKey, pending);
    return pending;
}

export function redirectToCheckout(url, userId, checkoutSessionId, details, returnRoute) {
    const target = new URL(url);
    if (target.protocol !== 'https:' || target.hostname !== 'checkout.stripe.com' ||
        !/^cs_(?:live|test)_[A-Za-z0-9]+$/.test(checkoutSessionId)) {
        throw new Error('Invalid Stripe checkout URL or session');
    }
    const previous = window.sessionStorage.getItem(storageKey);
    const pending = storeCheckoutReturn(userId, checkoutSessionId, details, returnRoute);
    try {
        window.location.assign(target.href);
    } catch (error) {
        if (window.sessionStorage.getItem(storageKey) === pending) {
            if (previous === null) window.sessionStorage.removeItem(storageKey);
            else window.sessionStorage.setItem(storageKey, previous);
        }
        throw error;
    }
}

export function readCheckoutReturn(userId) {
    const pending = pendingCheckout();
    if (!pending) return null;
    const url = new URL(window.location.href);
    const returnedSession = url.searchParams.get('session_id');
    if (pending.userId !== userId ||
        (returnedSession !== null && returnedSession !== pending.checkoutSessionId) ||
        (url.searchParams.get('stripe_checkout') === 'success' && returnedSession === null)) {
        clearCheckoutReturn(pending.checkoutSessionId);
        return null;
    }
    const returning = url.searchParams.has('stripe_checkout') || !pending.restored;
    const result = { ...pending, returnRoute: returning ? pending.returnRoute : null };
    if (!pending.restored) {
        pending.restored = true;
        window.sessionStorage.setItem(storageKey, JSON.stringify(pending));
    }
    return JSON.stringify(result);
}

export function restoreCheckoutReturnRoute(route) {
    const url = new URL(window.location.href);
    const isReturn = url.searchParams.has('stripe_checkout');
    if (isReturn) {
        url.searchParams.delete('stripe_checkout');
        url.searchParams.delete('session_id');
    }
    const routeChanged = route !== null && url.hash.replace(/^#/, '') !== route;
    if (route !== null) url.hash = route;
    if (isReturn || route !== null) {
        // Back can restore the original app entry with its navigation stack intact.
        window.history.replaceState(routeChanged ? null : window.history.state, '', url.href);
    }
}

export function clearCheckoutReturn(checkoutSessionId) {
    const pending = pendingCheckout();
    if (pending?.checkoutSessionId === checkoutSessionId) {
        window.sessionStorage.removeItem(storageKey);
    }
}

window.addEventListener('pageshow', (event) => {
    // BFCache can resume the old WASM purchase coroutine. Reboot through auth and reconciliation.
    if (event.persisted && pendingCheckout()) window.location.reload();
});
